import { useLayoutEffect, useState } from "react"

import useLocalStorage from "./useLocalStorage"

export const useTheme = (): [
  "light" | "dark",
  "light" | "dark" | "system",
  (theme: "light" | "dark" | "system") => void,
] => {
  const [systemTheme, setSystemTheme] = useState<"light" | "dark">(
    window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  )
  const [selectedTheme, setSelectedTheme] = useLocalStorage<"light" | "dark" | "system">("PROXY_THEME", "system")

  useLayoutEffect(() => {
    const onThemeChange = (e: MediaQueryListEvent) => {
      setSystemTheme(e.matches ? "dark" : "light")
    }
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", onThemeChange)
    return () => {
      window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", onThemeChange)
    }
  }, [])

  return [selectedTheme === "system" ? systemTheme : selectedTheme, selectedTheme, setSelectedTheme]
}

export default useTheme
